module.exports = __webpack_public_path__ + "img/tipee--icon--gray.9f18b3ff.svg";